<template>
  <div class="lg:mb-10 lg:flex lg:items-start">
    <div class="lg:grid lg:cols-2 lg:grow lg:gap-2 lg:pl-6 <lg:hidden">
      <div
        v-for="i in 6"
        :key="i"
        class="skeleton"
        :class="{
          'col-span-2': [3, 4].includes(i),
        }"
        :style="{ 'aspect-ratio': presets.src.width / presets.src.height }"
      />
    </div>
    <div
      class="skeleton lg:hidden"
      :style="{ 'aspect-ratio': presets.src.width / presets.src.height }"
    />
    <div
      v-style="{ w: { lg: '30rem' }, top: { lg: '9rem' } }"
      class="f-col gap-y-2 px-4 pb-4 lg:sticky lg:shrink-0 lg:px-6 lg:pt-4"
    >
      <div class="<lg:hidden space-y-2">
        <div class="mt-2 h-7 w-full skeleton" />
        <div class="h-4 w-75 skeleton" />
        <div class="h-4 w-30 skeleton" />
        <div class="h-4 w-64 skeleton" />
      </div>
      <div class="mb-4 mt-4 lg:mb-6">
        <div class="flex wrap -ml-2">
          <div
            v-for="i in 5"
            :key="i"
            class="m-2 skeleton"
            :style="{ width: '1.5rem', height: '1.5rem' }"
          />
        </div>
        <div class="mt-2 w-full flex between">
          <div class="h-4 w-24 skeleton" />
          <div class="h-4 w-24 skeleton" />
        </div>
      </div>
      <div class="lg:hidden space-y-2">
        <div class="mt-2 h-7 w-full skeleton" />
        <div class="h-4 w-75 skeleton" />
        <div class="h-4 w-30 skeleton" />
        <div class="h-4 w-64 skeleton" />
      </div>
      <div class="w-full flex gap-2">
        <div v-style:min-w="`7.5rem`" class="h-13 shrink skeleton" />
        <div class="h-13 grow skeleton" />
      </div>
      <div class="mt-2 w-full flex between">
        <div class="h-4 w-30 skeleton" />
        <div class="h-4 w-64 skeleton" />
      </div>
      <div class="mt-4 b-t b-grey-80" />
      <div class="mt-2 w-full flex gap-2">
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
      </div>
      <div class="mt-2 w-full flex gap-2 between">
        <div class="h-24 w-30 skeleton" />
        <div class="h-24 w-30 skeleton" />
        <div class="h-24 w-30 skeleton" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { presets } = useAppConfig().pages.pdp.gallery
</script>
